import React, {Component} from "react";
import PropTypes from 'prop-types';
import {CircularProgress, Typography, withStyles} from "@material-ui/core";
import queryString from 'query-string';
import {Redirect, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {initWifi} from "../redux/reducers/wifi";

const styles = theme => ({
    root: {
        height: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing.unit*2,
    }
});

//http://localhost:3000/guest/s/default/?id=24:18:1d:43:5f:01&ap=78:8a:20:29:58:0e&t=1526386069&url=http://connectivitycheck.gstatic.com%2fgenerate_204&ssid=Pantanova
class Collector extends Component {
    constructor() {
        super();

        this.state = {
            loading: true,
            error: null,
        }
    }

    componentDidMount() {
        const {initWifi} = this.props;
        initWifi(queryString.parse(window.location.search), window.location.search);

        this.setState({
            loading: false
        });
    }

    hasData() {
        const {ap, mac} = this.state;
        return !!ap && !!mac;
    }

    render() {
        const {classes, hasData, redirect} = this.props;
        const {loading} = this.state;

        if (loading) {
            return (
                <div className={classes.root}>
                    <CircularProgress className={classes.progress} size={100} />
                </div>
            );
        }

        if (!hasData) {
            return (
                <div className={classes.root}>
                    <Typography variant="display3" color="primary" className={classes.title}>
                        Hoppsan!
                    </Typography>
                    <Typography variant="display1" color="primary">
                        Använder du verkligen ett Pantanova WiFi?
                    </Typography>
                </div>
            )
        }

        return (
            <Redirect replace to={redirect} />
        );
    }
}

Collector.propTypes = {
    redirect: PropTypes.string,
};
Collector.defaultProps = {
    redirect: '/landing'
};

const mapStateToProps = (state) => ({
    hasData: !!state.wifi.mac && !!state.wifi.ap,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    initWifi
}, dispatch);


const DefaultCollector = compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
)(Collector);

export const PushCollector = (props) => <DefaultCollector {...props} redirect="/register/push" />;
export default DefaultCollector;



// WEBPACK FOOTER //
// ./src/containers/Collector.js